import { render, staticRenderFns } from "./ks-investor-4.vue?vue&type=template&id=e5f06a4a"
var script = {}
import style0 from "./ks-investor-4.vue?vue&type=style&index=0&id=e5f06a4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports